import React from "react";

export default function CreateVehicleSpareparts() {
  return (
    <div className="createvehiclespareparts-container my-4">
      <div className="col-md-12">
        <div className="special-header panel-white-all">
          <h4 className="page-title">Create Vehicle Spareparts</h4>
        </div>

        <form>
          <div className="row create-vehicle-sparepart-row">
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="vehicleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
              <select id="vehicleno" className="form-control createvehclespareparts-form-select" >
                <option>Select</option>
                <option>MH21WE9021</option>
                <option>MH02WE0002</option>
                <option>MH03BR8934</option>
              </select>
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="forspareparts" className="form-label">Spareparts<span className="text-danger">*</span>  </label>
              <input type="text" id="forspareparts" className="form-control createvehclespareparts-form-control" placeholder="Enter fuel quantity" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="forpurchase" className="form-label"> Purchase Date <span className="text-danger">*</span> </label>
              <input type="date" id="forpurchase" className="form-control createvehclespareparts-form-control" placeholder="Enter amount" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="expirydate" className="form-label"> Expiry Date <span className="text-danger">*</span> </label>
              <input type="date" id="expirydate" className="form-control createvehclespareparts-form-control" placeholder="Enter amount" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="foequantity" className="form-label">Quantity<span className="text-danger">*</span></label>
              <input  type="text"  id="forquantity"  className="form-control createvehclespareparts-form-control" />
            </div>

            
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="foramount" className="form-label">Amount<span className="text-danger">*</span></label>
              <input  type="text"  id="foramount"  className="form-control createvehclespareparts-form-control" />
            </div>

            
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="foewarranty" className="form-label">Warranty<span className="text-danger">*</span></label>
              <input  type="text"  id="forwarranty"  className="form-control createvehclespareparts-form-control" />
            </div>

            
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="foefile" className="form-label">Invoice<span className="text-danger">*</span></label>
              <input  type="file"  id="forfile"  className="form-control createvehclespareparts-form-control" />
            </div>

            <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
              <button type="submit" className="btn custom-btn">
                Create
              </button>
            </div>
            
          </div>
        </form>
      </div>
    </div>
  
    
  );
}
